import { Component, OnInit } from '@angular/core';
import { AnalyticsResultsService } from 'src/app/shared/services/analytics-results.service';

@Component({
  selector: 'app-balance-all-accounts-stat',
  templateUrl: './balance-all-accounts-stat.component.html',
  styleUrls: ['../widgets.scss', './balance-all-accounts-stat.component.scss']
})
export class BalanceAllAccountsStatComponent implements OnInit {
  currentBalance: number | undefined;
  constructor(private resultsAnalyticsSvc: AnalyticsResultsService) { }
  ngOnInit(): void {
    this.resultsAnalyticsSvc.getBankAccounts()
      .subscribe({
        next: (data) => {
          if(data && data.length > 0) {
            let balance = 0;
      
            data.forEach((x) =>{
              balance = balance + x.CurrentBalance;
            });
      
            this.currentBalance = balance;
          }
        }
      });
  }
}
